module.exports = __webpack_public_path__ + "static/assets/9ac1307982e5f39076114628e6e31cfb.png";